export function parseEmployFullDocumentByType(cnpj_basico: string, cnpj_ordem: string, cnpj_dv: string): string {  

  if(!cnpj_basico || !cnpj_ordem || !cnpj_dv){
    return 'Documento não informado.'
  }

  return `${cnpj_basico}${cnpj_ordem}${cnpj_dv}`
}